import appCssUrl from '../styles/app.css?url';

export type StylesType = { rel: string; href: string };

export const Styles: { [key: string]: StylesType[] } = {
  app: [{ rel: 'stylesheet', href: appCssUrl }],
  legalBoilerplate: [{ rel: 'stylesheet', href: appCssUrl }],
};
